import api from '../api';
const FEATURE_FLAG_URL = '/feature-flag';

export async function createFeatureFlag({ data }) {
  return api.post(FEATURE_FLAG_URL, { ...data });
}

export async function updateFeatureFlag({ code, description, isActive }) {
  return api.put(`${FEATURE_FLAG_URL}`, {
    code,
    description,
    isActive,
  });
}

export async function fetchAllFeatureFlags() {
  return api.get(FEATURE_FLAG_URL);
}
